import { gql } from "@apollo/client";

export const DELETE_VEHICLE = gql`
  mutation DeleteVehicle($vehicleId: String) {
    deleteVehicle(vehicleId: $vehicleId)
  }
`;
